import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { Container } from "reactstrap";
import Candidate from "../../layouts/Candidate";
import ReactLoading from "react-loading";
import { isEmailValid } from "../Documents/forms/Html/LeagleDocuments/forms/commonfunctions";
import { usePermissions } from "../../context/PermissionContext";

function Login() {
  const locationUrl = useLocation();
  const searchParams = new URLSearchParams(locationUrl.search);
  const continueTo = searchParams.get("continueTo") || "";
  const [loginErr, setLoginErr] = useState("");

  const history = useHistory();
  const { checkAllPermissions } = usePermissions();
  
  // const handleChange = (e) => {
  //   setLoginData({
  //     ...loginData,
  //     [e.target.name]: e.target.value,
  //   });
  // };

  useEffect(() => {
    const sessionCode = searchParams.get("session_code");

    // If user is not in user collection, logout from Keycloak and redirect to login
    const errorParam = searchParams.get("error");
    if (errorParam === "unauthorized") {
      localStorage.clear();
      window.location.href = `${process.env.REACT_APP_API_URL || 'http://localhost:4000/api'}/user/keycloak/logout`;
      return;
    }

    if (sessionCode) {
      fetch(`${process.env.REACT_APP_API_URL || 'http://localhost:4000/api'}/user/keycloak/exchange-session`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ session_code: sessionCode })
      })
      .then(res => res.json())
      .then(data => {
        if (data.error) {
           setLoginErr(data.error);
           return;
        }

        localStorage.clear();
        localStorage.setItem("user.token", data.token);
        localStorage.setItem("user.id", data.user.id);
        localStorage.setItem("user.name", data.user.name);
        localStorage.setItem("user.email", data.user.email);
        localStorage.setItem("user.role", data.user.role);

        if (data.refresh_token) {
          localStorage.setItem("user.refresh_token", data.refresh_token);
          const expiresIn = parseInt(data.expires_in || "300");
          const expiryTime = Date.now() + expiresIn * 1000;
          localStorage.setItem("user.token_expiry", expiryTime.toString());
          if (data.client_type) {
            localStorage.setItem("user.client_type", data.client_type);
          }
        }

        localStorage.setItem("selectInterviewRound", "Application_Received");

        const role = data.user.role;

        if (checkAllPermissions) {
          checkAllPermissions(role);
        }

        if (role === "client" || role === "consultant") {
          localStorage.clear();
          setLoginErr("Invalid User Role. Please contact administrator.");
          return;
        }

        localStorage.setItem("headerFilterStatus", "Application_Received");
        if (continueTo) {
          history.push(continueTo);
        } else {
          history.push("/candidate_dashboard?tab=Application_Received");
        }
      })
      .catch(err => {
         console.error(err);
         setLoginErr("Failed to process SSO login.");
      });
    } else if (!errorParam) {
      // Fetch the Keycloak auth URL from backend (returns JSON, no 302 redirect)
      // Then navigate using replace() so DH login page is NOT in browser history
      // This prevents the back-button OTP bypass: clicking back from Keycloak OTP page
      // goes to whatever page was before DH, not back to DH which would re-redirect
      const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:4000/api';
      fetch(`${apiUrl}/user/keycloak/auth-url`)
        .then(res => res.json())
        .then(data => {
          if (data.url) {
            window.location.replace(data.url);
          }
        })
        .catch(err => {
          console.error("Failed to get auth URL:", err);
          setLoginErr("Failed to connect to authentication server.");
        });
    }
  }, [locationUrl.search, history, continueTo]);

  return (
    <div className="container bg-white" style={{ minHeight: "100vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
      {loginErr ? (
        <Container>
          <Candidate>
            <div className="container thank text-center">
              <h1 className="mt-5 text-danger">
                {loginErr}
              </h1>
            </div>
          </Candidate>
        </Container>
      ) : (
        <div className="text-center">
          <h4 className="text-muted">Redirecting to Secure Login...</h4>
          <div className="spinner-border text-primary mt-3" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      )}
    </div>
  );
}

export default Login;

